<cmps-dialog>
    <div
        class="p-3"
        *ngIf="state?.pending?.init; else show"
    >
        <cmps-wait-status></cmps-wait-status>
    </div>
    <ng-template #show>
        <cmps-dialog-header>
            <div
                class="text-center cgtsst-header"
                role="heading"
                aria-level="1"
            >
                <span
                    *ngIf="
                        _options?.mode === _TagSetMode.DEFAULT ||
                        _options?.mode === _TagSetMode.FOCUS_ONLY
                    "
                >
                    {{ _i18n._9610_SELECT_A_FOCUS | translate }}
                </span>
                <span *ngIf="_options?.mode === _TagSetMode.METRIC_ONLY">
                    {{ _i18n._9778_SELECT_A_METRIC | translate }}
                </span>
            </div>
        </cmps-dialog-header>
        <cmps-dialog-body class="container">
            <ng-container
                *ngIf="
                    _options?.mode === _TagSetMode.DEFAULT ||
                    _options?.mode === _TagSetMode.FOCUS_ONLY
                "
            >
                <ng-container
                    *ngFor="let item of _tagItemViews; let ii = index"
                >
                    <div class="row">
                        <div class="col-12">
                            <div
                                class="cgtsst-recent-header"
                                role="heading"
                                aria-level="2"
                            >
                                <button
                                    class="cmps-icon-button--no-bg"
                                    cmpsIconButton
                                    (click)="_onToggleCollapseClick(item, ii)"
                                >
                                    <span cmpsIconButtonLabel>{{
                                        item.title | translate
                                    }}</span>
                                    <cmps-icon
                                        [svgIcon]="
                                            item.isCollapsed
                                                ? 'chevron-down'
                                                : 'chevron-up'
                                        "
                                    ></cmps-icon>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-2">
                        <div
                            class="col-12 cgtsst-tag-container"
                            [hidden]="item.isCollapsed"
                        >
                            <ng-container
                                *ngIf="
                                    item.tagItems.length !== 0;
                                    else placeholderBlock
                                "
                            >
                                <span
                                    class="cgtsst-tag"
                                    [class.cgtsst-tag-selected]="tag.isSelected"
                                    [title]="tag.tooltip"
                                    role="button"
                                    [attr.data-e2e]="
                                        'button-tag' +
                                        (tag.isActiveCommitment
                                            ? ' button-tag-active'
                                            : '')
                                    "
                                    (click)="_onRecentTagClick(tag)"
                                    (keyup.space)="_onRecentTagClick(tag)"
                                    (keyup.enter)="_onRecentTagClick(tag)"
                                    *ngFor="let tag of item.tagItems"
                                >
                                    {{ tag.name }}
                                </span>
                            </ng-container>
                        </div>
                    </div>
                </ng-container>
            </ng-container>
            <ng-template #placeholderBlock>
                <span class="cgtsst-tag-placeholder">&nbsp;</span>
                <span class="cgtsst-tag-placeholder">&nbsp;</span>
                <span class="cgtsst-tag-placeholder">&nbsp;</span>
            </ng-template>
            <div
                class="row mb-3"
                *ngIf="
                    _options?.mode === _TagSetMode.DEFAULT ||
                    _options?.mode === _TagSetMode.FOCUS_ONLY
                "
            >
                <div class="col-12">
                    <div class="input-group">
                        <div class="input-group-append">
                            <span class="input-group-text cgtsst-search-left">
                                <cmps-icon svgIcon="magnify"></cmps-icon>
                            </span>
                        </div>
                        <input
                            type="text"
                            class="form-control cgtsst-search-right"
                            [placeholder]="_i18n._710_SEARCH | translate"
                            [value]="_filterText"
                            (keyup)="_onFilterKeyUp(filterField.value)"
                            #filterField
                        />
                    </div>
                    <div
                        class="form-text text-muted ml-3"
                        [class.invisible]="
                            state?.filterText &&
                            state?.filterText.length >= _MIN_FILTER_TEXT_LENGTH
                        "
                    >
                        {{
                            _i18n._9614_PLEASE_ENTER_3_CHARACTERS_OR_MORE_FOR_THE_SEARCH_TO_PROCEED
                                | translate
                        }}
                    </div>
                </div>
            </div>
            <div
                class="row mb-3"
                *ngIf="
                    _options?.mode === _TagSetMode.DEFAULT ||
                    _options?.mode === _TagSetMode.FOCUS_ONLY
                "
            >
                <div class="col-6 px-2">
                    <div class="cgtsst-selection-container">
                        <div class="cgtsst-selection-header">
                            {{ _i18n._7334_BEHAVIOUR | translate }}
                        </div>
                        <div
                            class="cgtsst-selection-body"
                            data-behaviourscrollcontainer="empty"
                        >
                            <cmps-radio-group
                                class="d-inline-flex flex-column mb-2"
                                [value]="state?.selection?.behaviour?.id"
                                (change)="_onBehaviourChange($event)"
                            >
                                <cmps-radio
                                    [attr.data-behaviourid]="i.id"
                                    [value]="i.id"
                                    *ngFor="let i of state?.filteredBehaviours"
                                >
                                    {{ i.name }}
                                </cmps-radio>
                            </cmps-radio-group>
                        </div>
                    </div>
                </div>
                <div class="col-6 px-2">
                    <div class="cgtsst-selection-container">
                        <div class="cgtsst-selection-header">
                            {{ _i18n._7336_SUB_BEHAVIOUR | translate }}
                        </div>
                        <div
                            class="cgtsst-selection-body"
                            data-subbehaviourscrollcontainer="empty"
                        >
                            <div *ngIf="!state?.selection?.behaviour">
                                {{ _i18n._9596_SELECT_A_BEHAVIOUR | translate }}
                            </div>
                            <div
                                *ngIf="
                                    (!state?.filterText ||
                                        state?.filterText.length <
                                            _MIN_FILTER_TEXT_LENGTH) &&
                                    state?.filteredSubBehaviours &&
                                    !state?.filteredSubBehaviours.length
                                "
                            >
                                {{
                                    _i18n._9615_THIS_BEHAVIOUR_HAS_NO_SUB_BEHAVIOURS
                                        | translate
                                }}
                            </div>
                            <cmps-radio-group
                                class="d-inline-flex flex-column mb-2"
                                [value]="state?.selection?.subBehaviour?.id"
                                (change)="_onSubBehaviourChange($event)"
                                *ngIf="state?.selection?.behaviour"
                            >
                                <cmps-radio
                                    [attr.data-subbehaviourid]="i.id"
                                    [value]="i.id"
                                    *ngFor="
                                        let i of state?.filteredSubBehaviours
                                    "
                                >
                                    {{ i.name }}
                                </cmps-radio>
                            </cmps-radio-group>
                        </div>
                    </div>
                </div>
            </div>
            <div
                class="row mb-3"
                *ngIf="
                    _options?.mode === _TagSetMode.DEFAULT ||
                    _options?.mode === _TagSetMode.METRIC_ONLY
                "
            >
                <div class="col-12 px-2">
                    <div class="cgtsst-selection-container">
                        <div class="d-flex align-items-center mb-2">
                            <div
                                class="mb-0 ml-2 cgtsst-selection-metrics-header"
                            >
                                {{
                                    _i18n._9616_FOCUS_KPIS__METRICS_ | translate
                                }}
                            </div>
                            <div
                                class="d-flex align-items-center justify-content-center flex-grow-1"
                            >
                                <div>
                                    <cmps-icon
                                        class="cgtsst-uncoached"
                                        svgIcon="alert-circle"
                                    ></cmps-icon>
                                    <span class="align-middle">{{
                                        _i18n._7489_UNCOACHED | translate
                                    }}</span>
                                </div>
                                <div class="ml-4">
                                    <cmps-icon
                                        class="cgtsst-coached"
                                        svgIcon="alert-circle"
                                    ></cmps-icon>
                                    <span class="align-middle">{{
                                        _i18n._7488_COACHED | translate
                                    }}</span>
                                </div>
                                <div class="ml-4">
                                    <cmps-icon
                                        class="cgtsst-non-opportunity"
                                        svgIcon="alert-circle"
                                    ></cmps-icon>
                                    <span class="align-middle">{{
                                        _i18n._7436_NON_OPPORTUNITY | translate
                                    }}</span>
                                </div>
                                <div class="ml-4">
                                    <cmps-icon
                                        class="cgtsst-on-scorecard"
                                        svgIcon="check-circle"
                                    ></cmps-icon>
                                    <span class="align-middle">{{
                                        _i18n._9617_ON_SCORECARD | translate
                                    }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 px-2">
                            <div class="input-group">
                                <div class="input-group-append">
                                    <span
                                        class="input-group-text cgtsst-search-left"
                                    >
                                        <cmps-icon
                                            svgIcon="magnify"
                                        ></cmps-icon>
                                    </span>
                                </div>
                                <input
                                    type="text"
                                    class="form-control cgtsst-search-right"
                                    [placeholder]="
                                        _i18n._710_SEARCH | translate
                                    "
                                    [value]="_filterMetricText"
                                    (keyup)="
                                        _onFilterKeyUpMetric(
                                            filterFieldMetric.value
                                        )
                                    "
                                    #filterFieldMetric
                                />
                            </div>
                            <div
                                class="form-text text-muted ml-3"
                                [class.invisible]="
                                    state?.filterMetricText &&
                                    state?.filterMetricText.length >=
                                        _MIN_FILTER_TEXT_LENGTH
                                "
                            >
                                {{
                                    _i18n._9614_PLEASE_ENTER_3_CHARACTERS_OR_MORE_FOR_THE_SEARCH_TO_PROCEED
                                        | translate
                                }}
                            </div>
                        </div>
                        <div class="cgtsst-selection-body">
                            <div
                                ngGrid
                                [rendererOptions]="_rendererOpts"
                                [selectTemplate]="_selectTpl"
                                [rowsTop]="state?.gridRowsTop"
                                [rows]="state?.gridRows"
                                [sortDefs]="state?.gridSortDefs"
                                #grid
                            >
                                <ng-template
                                    gridContent
                                    data-type="grid"
                                >
                                    <div></div>
                                </ng-template>

                                <ng-template
                                    gridContent
                                    data-type="row"
                                    data-id="header"
                                >
                                    <div class="cgtsst-grid-row-header"></div>
                                </ng-template>

                                <ng-template
                                    gridContent
                                    data-type="row"
                                    data-id="content"
                                >
                                    <div class="cgtsst-grid-row-content"></div>
                                </ng-template>

                                <ng-template
                                    gridContent
                                    data-type="cell"
                                    data-id="header"
                                    let-c="c"
                                >
                                    <div [ngSwitch]="c.id">
                                        <div
                                            *ngSwitchCase="_ColumnID.METRIC"
                                            class="cgtsst-grid-metric-header"
                                        >
                                            {{ _i18n._713_METRIC | translate }}
                                        </div>
                                        <div
                                            *ngSwitchDefault
                                            class="cgtsst-grid-other"
                                        >
                                            <button
                                                class="cmps-button--no-bg"
                                                cmpsButton
                                                [attr.data-e2e]="
                                                    'button-sort-' + c.id
                                                "
                                                (click)="_onSortClick(c)"
                                            >
                                                <span
                                                    cmpsButtonLabel
                                                    *ngIf="
                                                        c.id === _ColumnID.OA
                                                    "
                                                >
                                                    {{
                                                        _i18n._7463_OA
                                                            | translate
                                                    }}
                                                </span>
                                                <span
                                                    cmpsButtonLabel
                                                    *ngIf="
                                                        c.id ===
                                                        _ColumnID.ON_SCORECARD
                                                    "
                                                >
                                                    {{
                                                        _i18n._9617_ON_SCORECARD
                                                            | translate
                                                    }}
                                                </span>
                                                <cmps-icon
                                                    [svgIcon]="
                                                        state?.gridSortDefs[0]
                                                            .order ===
                                                        _SortOrder.ASC
                                                            ? 'chevron-up'
                                                            : 'chevron-down'
                                                    "
                                                    *ngIf="
                                                        state?.gridSortDefs &&
                                                        state?.gridSortDefs
                                                            .length &&
                                                        state?.gridSortDefs[0]
                                                            .columnId === c.id
                                                    "
                                                ></cmps-icon>
                                                <cmps-icon
                                                    svgIcon="unfold-more-horizontal"
                                                    *ngIf="
                                                        !state?.gridSortDefs ||
                                                        !state?.gridSortDefs
                                                            .length ||
                                                        state?.gridSortDefs[0]
                                                            .columnId !== c.id
                                                    "
                                                ></cmps-icon>
                                            </button>
                                        </div>
                                    </div>
                                </ng-template>

                                <ng-template
                                    gridContent
                                    data-type="cell"
                                    data-id="content"
                                    let-c="c"
                                    let-l="l"
                                    let-ctx="ctx"
                                >
                                    <div [ngSwitch]="c.id">
                                        <div
                                            *ngSwitchCase="_ColumnID.METRIC"
                                            class="cgtsst-grid-metric"
                                        >
                                            <cmps-checkbox
                                                variant="radio"
                                                [name]="ctx.metric.metricName"
                                                [checked]="ctx.checked"
                                                (change)="
                                                    _onMetricClick(
                                                        ctx.metric.metricId,
                                                        $event
                                                    )
                                                "
                                            >
                                                {{ ctx.metric.metricName }}
                                            </cmps-checkbox>
                                        </div>
                                        <div
                                            *ngSwitchCase="_ColumnID.OA"
                                            class="cgtsst-grid-other"
                                        >
                                            <cmps-icon
                                                [class.cgtsst-non-opportunity]="
                                                    ctx.metric.coachTypeId ===
                                                    _CoachingType.NON_OPPORTUNITY
                                                "
                                                [class.cgtsst-coached]="
                                                    ctx.metric.coachTypeId ===
                                                    _CoachingType.COACHED
                                                "
                                                [class.cgtsst-uncoached]="
                                                    ctx.metric.coachTypeId ===
                                                    _CoachingType.UNCOACHED
                                                "
                                                svgIcon="alert-circle"
                                                *ngIf="
                                                    ctx.metric.coachTypeId !=
                                                    null
                                                "
                                            ></cmps-icon>
                                        </div>
                                        <div
                                            *ngSwitchCase="
                                                _ColumnID.ON_SCORECARD
                                            "
                                            class="cgtsst-grid-other"
                                        >
                                            <cmps-icon
                                                class="cgtsst-on-scorecard"
                                                svgIcon="check-circle"
                                                *ngIf="ctx.metric.isInScorecard"
                                            ></cmps-icon>
                                        </div>
                                    </div>
                                </ng-template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-12">
                    <div
                        *ngIf="
                            _options?.mode === _TagSetMode.DEFAULT ||
                            _options?.mode === _TagSetMode.FOCUS_ONLY
                        "
                    >
                        <span
                            >{{
                                _i18n._9618_SELECTED_BEHAVIOUR___SUB_BEHAVIOUR_
                                    | translate
                            }}&nbsp;</span
                        >
                        <span class="cgtsst-selected">{{
                            state?.selectionBehaviourStr || '-'
                        }}</span>
                    </div>
                    <div
                        *ngIf="
                            _options?.mode === _TagSetMode.DEFAULT ||
                            _options?.mode === _TagSetMode.METRIC_ONLY
                        "
                    >
                        <span
                            >{{
                                _i18n._9619_SELECTED_KPIS_ | translate
                            }}&nbsp;</span
                        >
                        <span class="cgtsst-selected">{{
                            state?.selectionMetricsStr || '-'
                        }}</span>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 d-flex justify-content-center">
                    <button
                        cmpsButton
                        [disabled]="
                            _options?.mode === _TagSetMode.DEFAULT ||
                            _options?.mode === _TagSetMode.FOCUS_ONLY
                                ? !state?.selection?.behaviour
                                : !state?.selection?.metrics?.size
                        "
                        (click)="_onSetSelectedFocusClick()"
                    >
                        <span
                            cmpsButtonLabel
                            *ngIf="
                                _options?.mode === _TagSetMode.DEFAULT ||
                                _options?.mode === _TagSetMode.FOCUS_ONLY
                            "
                        >
                            {{ _i18n._9620_SET_SELECTED_FOCUS | translate }}
                        </span>
                        <span
                            cmpsButtonLabel
                            *ngIf="_options?.mode === _TagSetMode.METRIC_ONLY"
                            >{{
                                _i18n._9621_ADD_SELECTED_METRICS | translate
                            }}</span
                        >
                    </button>
                </div>
            </div>
        </cmps-dialog-body>
    </ng-template>
</cmps-dialog>
